import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  programCollectionWrapper: {
    ...theme.mixins.appClickableContainer,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    minWidth: 0,
    ...theme.mixins.appContainersSpacing,
  },
  programCollectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    flex: 1,
    minWidth: 0,

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(1),
      alignItems: 'flex-start',
    },
  },
  programCollectionInfoWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    flex: 1,
    minWidth: 0,
  },
  programCollectionHeaderButtonsWrapper: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'flex-start',
    flexShrink: 0,
  },
  programInfoWrapper: {
    flex: 1,
    minWidth: 0,
  },
  programName: {
    fontWeight: 600,
    fontSize: 14,
    marginBottom: theme.spacing(0.5),
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  ownerName: {
    fontSize: 14,
  },

  menuItem: {},
  icon: {
    marginRight: theme.spacing(2),
    // '&:hover': {
    //   '& svg': {
    //     color: theme.palette.grey[600],
    //   },
    // },
  },
}));
